import { IPermission, IUserProfile, ShortEntityResponse } from 'reducers/Reducers.interfaces'

export function filterPermissions (permissions: ShortEntityResponse[], profilePermissions: ShortEntityResponse[]): ShortEntityResponse[] {
  return permissions.filter(p => profilePermissions.find(pp => pp.id === p.id))
}

export function getAllPermissionsBasedOnUserMeApi (allPermissions: Record<string, ShortEntityResponse[]>, userProfile?: IUserProfile) : Record<string, IPermission[]> {
  const allPerms = Object.keys(allPermissions).sort().reduce(
    (obj, key) => { 
      obj[key] = allPermissions[key]; 
      return obj;
    }, 
    {}
  );
  userProfile?.applications.map(application => {
    if (!Object.keys(allPermissions).includes(application.app_code.toUpperCase())) {
      delete allPerms[application.app_code.toUpperCase()]
    }
  })
  return allPerms
}
